import { ApolloLink } from '@apollo/client'
import { debugLog } from '@/utils'

export default new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    // @ts-expect-error response.errors is valid in some cases, upgrading apollo client broke
    // https://github.com/apollographql/apollo-client/issues/9292
    if (response?.errors?.length) {
      // @ts-expect-error response.errors is valid in some cases, upgrading apollo client broke
      debugLog(response.errors, 'warn')
    }

    return response
  })
)
